import ResendInviteLinkSent from './ResendInviteLinkSent'

export default ResendInviteLinkSent
